var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
/**
 * @module resources/pdf/generate
 */
module.exports = {
  //Transporte
  generateUserDeliveryNote: generateUserDeliveryNote,
  generateJoberDeliveryNote: generateJoberDeliveryNote,
  generateJobinDeliveryNote: generateJobinDeliveryNote,
  generateWarehouseDeliveryNote: generateWarehouseDeliveryNote,
  //Transporte (cambio)
  generateUserDeliveryChangeNote: generateUserDeliveryChangeNote,
  generateJoberDeliveryChangeNote: generateJoberDeliveryChangeNote,
  generateJobinDeliveryChangeNote: generateJobinDeliveryChangeNote,
  // Transporte (devolución)
  generateUserDeliveryReturnNote: generateUserDeliveryReturnNote,
  generateJoberDeliveryReturnNote: generateJoberDeliveryReturnNote,
  generateJobinDeliveryReturnNote: generateJobinDeliveryReturnNote,
  //Precio fijo
  generateFixedJobinNote: generateFixedJobinNote,
  generateFixedUserNote: generateFixedUserNote,
  generateFixedJoberNote: generateFixedJoberNote,
  //Precio fijo (Garantía)
  generateFixedUserGuaranteeNote: generateFixedUserGuaranteeNote,
  generateFixedJoberGuaranteeNote: generateFixedJoberGuaranteeNote,
  generateFixedJobinGuaranteeNote: generateFixedJobinGuaranteeNote
};
var path = undefined;
var resFormat = require("../format");
var pdfTemplates = require("./templates");
var resImages = require("../image");
var Parse = require("parse");

/**
 * Generates a PDF file (in base64 format) from a DocumentDefinition (NODE VERSION)
 * @param  {PDFMake.DocumentDefinition} docDefinition A JSON object defining he contents of the file
 * @return {Promise.<string>}               Promise containig a base64 string defining the PDF file
 */
function __getPFDBase64_SERVER(docDefinition) {
  return new Promise(function (resolve, reject) {
    try {
      var fonts = {
        Roboto: {
          normal: path.join(__dirname, "../../../../assets/fonts/Roboto-Regular.ttf"),
          bold: path.join(__dirname, "../../../../assets/fonts/Roboto-Medium.ttf"),
          italics: path.join(__dirname, "../../../../assets/fonts/Roboto-Italic.ttf"),
          bolditalics: path.join(__dirname, "../../../../assets/fonts/Roboto-MediumItalic.ttf")
        }
      };
      var PdfPrinter = require("pdfmake");
      var printer = new PdfPrinter(fonts);
      var doc = printer.createPdfKitDocument(docDefinition);
      var chunks = [];
      var result;
      doc.on("data", function (chunk) {
        chunks.push(chunk);
      });
      doc.on("end", function () {
        result = Buffer.concat(chunks);
        resolve("data:application/pdf;base64," + result.toString("base64"));
      });
      doc.end();
    } catch (error) {
      reject(error);
    }
  });
}
/**
 * Generates a PDF file (in base64 format) from a DocumentDefinition (NODE VERSION)
 * @param  {PDFMake.DocumentDefinition} docDefinition A JSON object defining he contents of the file
 * @return {Promise.<string>}               Promise containig a base64 string defining the PDF file
 */

function __getPFDBase64_CLIENT(docDefinition) {
  var pdfMake = require("pdfmake");
  pdfMake.vfs = require("./vfs_fonts");
  var pdf = pdfMake.createPdf(docDefinition);
  return new Promise(function (resolve, reject) {
    try {
      pdf.getBase64(function (pdf64) {
        resolve("data:application/pdf;base64," + pdf64);
      });
    } catch (e) {
      reject(e);
    }
  });
}
function __getPFDBase64(docDefinition) {
  return __getPFDBase64_CLIENT(docDefinition);
}
/**
 * Generates a PDF file (in Parse.File format) from a DocumentDefinition
 * @param  {PDFMake.DocumentDefinition} docDefinition A JSON object defining he contents of the file
 * @param  {string} filename      Name for the file (with extension)
 * @return {Parse.File}               An (already saved) Parse File
 */

function __createParsePDF(docDefinition, filename) {
  var getBase64Promise = __getPFDBase64(docDefinition);
  var savePromise = getBase64Promise.then(function (base64) {
    var file = new Parse.File(filename, {
      base64: base64
    });
    return file.save();
  });
  return savePromise;
}
/**
 * Generates a PDF file (in Parse.File format) from a DocumentDefinition
 * @param  {PDFMake.DocumentDefinition} docDefinition A JSON object defining he contents of the file
 * @param  {string} filename      Name for the file (with extension)
 * @return {{file :Parse.File, filename : string, base64: string}}               An struct contaning (already saved) Parse File, the filename (same as parameter), and the base64 representation of the file
 */

function __createRichParsePDF(docDefinition, filename) {
  var getBase64Promise = __getPFDBase64(docDefinition);
  var savePromise = getBase64Promise.then(function (base64) {
    var file = new Parse.File(filename, {
      base64: base64
    });
    return file.save();
  });
  return Promise.all([getBase64Promise, savePromise]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      base64 = _ref2[0],
      file = _ref2[1];
    return {
      file: file,
      filename: filename,
      base64: base64
    };
  });
}
/**
 * Generates a Transportation delivery note (user version)
 * @param  {Parse.Object} transportation Transportation object
 * @param  {Parse.Object} job Job object
 * @param  {Parse.User} user User object
 * @param  {Object} paymentSummary Summary of payments
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateUserDeliveryNote(transportation, job, user, paymentSummary) {
  var priceBreakdown = __getSingleItemPriceBreakdown("Transporte de mercanc\xEDa", transportation.get("Price"));
  var docDef = pdfTemplates.getUserDeliveryNoteDefinition(transportation.get("ID"), job.get("Description"), transportation.has("DeliveryDate") ? resFormat.formatDate(transportation.get("DeliveryDate")) : "Sin especificar", priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), Math.ceil(transportation.get("Distance")), transportation.get("Weight"), __formatPaymentSummary(paymentSummary));
  return __createParsePDF(docDef, transportation.get("ID") + "-usuario.pdf");
}
/**
 * Generates a Transportation delivery note (jober version)
 * @param  {Parse.Object} transportation Transportation object
 * @param  {Parse.Object} job Job object
 * @param  {Parse.User} user User object
 * @param  {Object} paymentSummary Summary of payments
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateJoberDeliveryNote(transportation, job, user, paymentSummary) {
  var priceBreakdown = __getSingleItemPriceBreakdown("Transporte de mercanc\xEDa", transportation.get("Price"));
  var docDef = pdfTemplates.getJoberDeliveryNoteDefinition(transportation.get("ID"), job.get("Description"), transportation.has("DeliveryDate") ? resFormat.formatDate(transportation.get("DeliveryDate")) : "Sin especificar", priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), Math.ceil(transportation.get("Distance")), transportation.get("Weight"), __formatPaymentSummary(paymentSummary));
  return __createParsePDF(docDef, transportation.get("ID") + "-profesional.pdf");
}
/**
 * Generates a Transportation delivery note (Jobin version)
 * @param  {Parse.Object} transportation Transportation object
 * @param  {Parse.Object} job Job object
 * @param  {Parse.User} user User object
 * @param  {Object} paymentSummary Summary of payments
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateJobinDeliveryNote(transportation, job, user, paymentSummary) {
  var priceBreakdown = __getSingleItemPriceBreakdown("Transporte de mercanc\xEDa", transportation.get("Price"));
  var docDef = pdfTemplates.getJobinDeliveryNoteDefinition(transportation.get("ID"), job.get("Description"), transportation.has("DeliveryDate") ? resFormat.formatDate(transportation.get("DeliveryDate")) : "Sin especificar", priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), Math.ceil(transportation.get("Distance")), transportation.get("Weight"), __formatPaymentSummary(paymentSummary));
  return __createParsePDF(docDef, transportation.get("ID") + "-jobin.pdf");
}
/**
 * Generates a Transportation delivery note (warehouse version)
 * @param  {Parse.Object} transportation Transportation object
 * @param  {Parse.Object} job Job object
 * @param  {Parse.User} user User object
 * @param  {Object} paymentSummary Summary of payments
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateWarehouseDeliveryNote(transportation, job, user, paymentSummary) {
  var priceBreakdown = __getSingleItemPriceBreakdown("Transporte de mercanc\xEDa", transportation.get("Price"));
  var docDef = pdfTemplates.getWarehouseDeliveryNoteDefinition(transportation.get("ID"), job.get("Description"), transportation.has("DeliveryDate") ? resFormat.formatDate(transportation.get("DeliveryDate")) : "Sin especificar", priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), Math.ceil(transportation.get("Distance")), transportation.get("Weight"), __formatPaymentSummary(paymentSummary));
  return __createParsePDF(docDef, transportation.get("ID") + "-almacen.pdf");
}
/**
 * Generates a Transportation change delivery note (user version)
 * @param  {Parse.Object} transportation Transportation object
 * @param  {Parse.Object} job Job object
 * @param  {Parse.User} user User object
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateUserDeliveryChangeNote(transportation, job, user) {
  var priceBreakdown = __getSingleItemPriceBreakdown("Sustituci\xF3n de mercanc\xEDa", transportation.get("Price"));
  var docDef = pdfTemplates.getUserDeliveryChangeNoteDefinition(transportation.get("ID"), job.get("Description"), transportation.has("DeliveryDate") ? resFormat.formatDate(transportation.get("DeliveryDate")) : "Sin especificar", priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), Math.ceil(transportation.get("Distance")), transportation.get("Weight"));
  return __createParsePDF(docDef, transportation.get("ID") + "-usuario.pdf");
}
/**
 * Generates a Transportation change delivery note (jober version)
 * @param  {Parse.Object} transportation Transportation object
 * @param  {Parse.Object} job Job object
 * @param  {Parse.User} user User object
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateJoberDeliveryChangeNote(transportation, job, user) {
  var priceBreakdown = __getSingleItemPriceBreakdown("Sustituci\xF3n de mercanc\xEDa", transportation.get("Price"));
  var docDef = pdfTemplates.getJoberDeliveryChangeNoteDefinition(transportation.get("ID"), job.get("Description"), transportation.has("DeliveryDate") ? resFormat.formatDate(transportation.get("DeliveryDate")) : "Sin especificar", priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), Math.ceil(transportation.get("Distance")), transportation.get("Weight"));
  return __createParsePDF(docDef, transportation.get("ID") + "-profesional.pdf");
}
/**
 * Generates a Transportation change delivery note (Jobin version)
 * @param  {Parse.Object} transportation Transportation object
 * @param  {Parse.Object} job Job object
 * @param  {Parse.User} user User object
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateJobinDeliveryChangeNote(transportation, job, user) {
  var priceBreakdown = __getSingleItemPriceBreakdown("Sustituci\xF3n de mercanc\xEDa", transportation.get("Price"));
  var docDef = pdfTemplates.getJobinDeliveryChangeNoteDefinition(transportation.get("ID"), job.get("Description"), transportation.has("DeliveryDate") ? resFormat.formatDate(transportation.get("DeliveryDate")) : "Sin especificar", priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), Math.ceil(transportation.get("Distance")), transportation.get("Weight"));
  return __createParsePDF(docDef, transportation.get("ID") + "-jobin.pdf");
}
/**
 * Generates a Transportation return delivery note (user version)
 * @param  {Parse.Object} transportation Transportation object
 * @param  {Parse.Object} job Job object
 * @param  {Parse.User} user User object
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateUserDeliveryReturnNote(transportation, job, user) {
  var priceBreakdown = __getSingleItemPriceBreakdown("Devoluci\xF3n de mercanc\xEDa", transportation.get("Price"));
  var docDef = pdfTemplates.getUserDeliveryReturnNoteDefinition(transportation.get("ID"), job.get("Description"), transportation.has("DeliveryDate") ? resFormat.formatDate(transportation.get("DeliveryDate")) : "Sin especificar", priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), Math.ceil(transportation.get("Distance")), transportation.get("Weight"));
  return __createParsePDF(docDef, transportation.get("ID") + "-usuario.pdf");
}
/**
 * Generates a Transportation return delivery note (jober version)
 * @param  {Parse.Object} transportation Transportation object
 * @param  {Parse.Object} job Job object
 * @param  {Parse.User} user User object
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateJoberDeliveryReturnNote(transportation, job, user) {
  var priceBreakdown = __getSingleItemPriceBreakdown("Devoluci\xF3n de mercanc\xEDa", transportation.get("Price"));
  var docDef = pdfTemplates.getJoberDeliveryReturnNoteDefinition(transportation.get("ID"), job.get("Description"), transportation.has("DeliveryDate") ? resFormat.formatDate(transportation.get("DeliveryDate")) : "Sin especificar", priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), Math.ceil(transportation.get("Distance")), transportation.get("Weight"));
  return __createParsePDF(docDef, transportation.get("ID") + "-profesional.pdf");
}
/**
 * Generates a Transportation return delivery note (jobin version)
 * @param  {Parse.Object} transportation Transportation object
 * @param  {Parse.Object} job Job object
 * @param  {Parse.User} user User object
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateJobinDeliveryReturnNote(transportation, job, user) {
  var priceBreakdown = __getSingleItemPriceBreakdown("Devoluci\xF3n de mercanc\xEDa", transportation.get("Price"));
  var docDef = pdfTemplates.getJobinDeliveryReturnNoteDefinition(transportation.get("ID"), job.get("Description"), transportation.has("DeliveryDate") ? resFormat.formatDate(transportation.get("DeliveryDate")) : "Sin especificar", priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), Math.ceil(transportation.get("Distance")), transportation.get("Weight"));
  return __createParsePDF(docDef, transportation.get("ID") + "-jobin.pdf");
}
/**
 * @typedef {Object} PriceBreakdown
 * @property {string[]} name   Job tasks names
 * @property {number[]} units   Units of each task
 * @property {string[]} pricePerUnit  Formatted price (with IVA) for each unit
 * @property {string[]} totalPrice Formatted price (with IVA) for all units of a task
 * @property {string} total Formatted price (with IVA) of the global job price
 */

/**
 * @typedef   {Object[]} Extras
 * @property  {string} [extras[].id] objectId of the extra (if it's a default extra from the server)
 * @property  {string} extras[].name     Name of the extra
 * @property  {number} extras[].units     Number of units for the extra (positive integer)
 * @property  {number} extras[].pricePerUnit     Price for each unit of the extra (in euros without IVA, may be negative)
 * @property  {number} extras[].joberPricePerUnit     Jober Price for each unit of the extra (in euros without IVA)
 */

/**
 * Formats the fixed job basic an extra prices
 * @param  {number} basicPrice    Price of the basic service (without IVA)
 * @param  {number} totalPrice    Price of the full service, with all extras (without IVA)
 * @param  {Extras} [extras]     Object defining the job extras. Properties name, units and pricePerUnit must exist
 * @return {PriceBreakdown}               [description]
 */

function __getPriceBreakdown(jobTitle, basicPrice, totalPrice, extras) {
  var priceBreakdown = {
    name: [],
    units: [],
    pricePerUnitNoIVA: [],
    totalPriceNoIVA: [],
    totalNoIVA: resFormat.formatPrice(totalPrice),
    IVA: resFormat.formatPrice(totalPrice * 0.21),
    total: resFormat.formatPrice(totalPrice * 1.21)
  };
  if (basicPrice !== 0) {
    priceBreakdown["name"].push(jobTitle || "Servicio básico");
    priceBreakdown["units"].push(1);
    priceBreakdown["pricePerUnitNoIVA"].push(resFormat.formatPrice(basicPrice));
    priceBreakdown["totalPriceNoIVA"].push(resFormat.formatPrice(basicPrice));
  }
  if (extras) for (var i = 0; i < extras.length; i++) {
    priceBreakdown["name"].push(extras[i].name);
    priceBreakdown["units"].push(extras[i].units);
    priceBreakdown["pricePerUnitNoIVA"].push(resFormat.formatPrice(extras[i].pricePerUnit));
    priceBreakdown["totalPriceNoIVA"].push(resFormat.formatPrice(extras[i].pricePerUnit * extras[i].units));
  }
  return priceBreakdown;
}
/**
 * Formats the fixed job basic an extra prices
 * @param  {number} price    Price of the basic service (without IVA)
 * @return {PriceBreakdown}               [description]
 */

function __getSingleItemPriceBreakdown(description, price) {
  var priceBreakdown = {
    name: [description],
    units: [1],
    pricePerUnitNoIVA: [resFormat.formatPrice(price)],
    totalPriceNoIVA: [resFormat.formatPrice(price)],
    totalNoIVA: resFormat.formatPrice(price),
    IVA: resFormat.formatPrice(price * 0.21),
    total: resFormat.formatPrice(price * 1.21)
  };
  return priceBreakdown;
}
function __formatPaymentSummary(paymentSummary) {
  var paid = {},
    pending = {};
  for (var method in paymentSummary.pending) {
    pending[resFormat.formatPaymentMethod(method)] = resFormat.formatPrice(paymentSummary.pending[method] * 1.21) + " €";
  }
  for (var _method in paymentSummary.paid) {
    paid[resFormat.formatPaymentMethod(_method)] = resFormat.formatPrice(paymentSummary.paid[_method] * 1.21) + " €";
  }
  return {
    paid: paid,
    pending: pending
  };
}
/**
 * Generates a Fixed job note (Jobin version)
 * @param  {Parse.Object} fixedInfo     Fixed into object
 * @param  {Parse.Object} job           Job object
 * @param  {Parse.User} user          User Object
 * @param  {Parse.Object} subvertical   Leaf vertical object
 * @param  {Object} paymentSummary Summary of payments
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateFixedJobinNote(fixedInfo, job, user, subvertical, paymentSummary) {
  var priceBreakdown = __getPriceBreakdown(subvertical ? subvertical.get("JobTitle") : "", fixedInfo.get("BasicPrice"), fixedInfo.get("FixedPrice"), fixedInfo.get("Extras"));
  var docDef = pdfTemplates.getFixedJobinNoteDefinition(fixedInfo.get("ID"), resFormat.formatDate(fixedInfo.get("createdAt")), priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), subvertical ? subvertical.get("JobTitle") : "", job.get("Description"), subvertical && subvertical.has("Includes") ? subvertical.get("Includes") : [], subvertical && subvertical.has("DoesntInclude") ? subvertical.get("DoesntInclude") : [], __formatPaymentSummary(paymentSummary));
  return __createParsePDF(docDef, fixedInfo.get("ID") + "-jobin.pdf");
}
/**
 * Generates a Fixed guarantee job note (user version)
 * @param  {FixedInfo} fixedInfo     Fixed info object (from new job)
 * @param  {FixedInfo} oldFixedInfo     Fixed info object (from related job)
 * @param  {Job} job           Job object
 * @param  {User} user          User Object
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateFixedUserGuaranteeNote(fixedInfo, oldFixedInfo, job, user) {
  var docDef = pdfTemplates.getFixedUserGuaranteeNoteDefinition(fixedInfo.get("ID"), oldFixedInfo.get("ID"), resFormat.formatDate(fixedInfo.get("createdAt")), user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), job.get("Description"));
  return __createParsePDF(docDef, fixedInfo.get("ID") + "-usuario.pdf");
}
/**
 * Generates a Fixed guarantee job note (jobin version)
 * @param  {FixedInfo} fixedInfo     Fixed info object (from new job)
 * @param  {FixedInfo} oldFixedInfo     Fixed info object (from related job)
 * @param  {Job} job           Job object
 * @param  {User} user          User Object
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateFixedJobinGuaranteeNote(fixedInfo, oldFixedInfo, job, user) {
  var docDef = pdfTemplates.getFixedJobinGuaranteeNoteDefinition(fixedInfo.get("ID"), oldFixedInfo.get("ID"), resFormat.formatDate(fixedInfo.get("createdAt")), user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), job.get("Description"));
  return __createParsePDF(docDef, fixedInfo.get("ID") + "-jobin.pdf");
}
/**
 * Generates a Fixed guarantee job note (jobin version)
 * @param  {FixedInfo} fixedInfo     Fixed info object (from new job)
 * @param  {FixedInfo} oldFixedInfo     Fixed info object (from related job)
 * @param  {Job} job           Job object
 * @param  {User} user          User Object
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateFixedJoberGuaranteeNote(fixedInfo, oldFixedInfo, job, user) {
  var docDef = pdfTemplates.getFixedJoberGuaranteeNoteDefinition(fixedInfo.get("ID"), oldFixedInfo.get("ID"), resFormat.formatDate(fixedInfo.get("createdAt")), user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), job.get("Description"));
  return __createParsePDF(docDef, fixedInfo.get("ID") + "-profesional.pdf");
}
/**
 * Generates a Fixed job note (user version)
 * @param  {Parse.Object} fixedInfo     Fixed into object
 * @param  {Parse.Object} job           Job object
 * @param  {Parse.User} user          User Object
 * @param  {Parse.Object} subvertical   Leaf vertical object
 * @param  {Object} paymentSummary Summary of payments
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateFixedUserNote(fixedInfo, job, user, subvertical, paymentSummary) {
  var priceBreakdown = __getPriceBreakdown(subvertical ? subvertical.get("JobTitle") : "", fixedInfo.get("BasicPrice"), fixedInfo.get("FixedPrice"), fixedInfo.get("Extras"));
  var docDef = pdfTemplates.getFixedUserNoteDefinition(fixedInfo.get("ID"), resFormat.formatDate(fixedInfo.get("createdAt")), priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), subvertical ? subvertical.get("JobTitle") : "", job.get("Description"), subvertical && subvertical.has("Includes") ? subvertical.get("Includes") : [], subvertical && subvertical.has("DoesntInclude") ? subvertical.get("DoesntInclude") : [], __formatPaymentSummary(paymentSummary));
  return __createParsePDF(docDef, fixedInfo.get("ID") + "-usuario.pdf");
}
/**
 * Generates a Fixed job note (jober version)
 * @param  {FixedInfo} fixedInfo     Fixed into object
 * @param  {Job} job           Job object
 * @param  {User} user          User Object
 * @param  {Vertical} subvertical   Leaf vertical object
 * @return {Parse.File}               An (already saved) Parse File
 */

function generateFixedJoberNote(fixedInfo, job, user, subvertical) {
  var priceBreakdown = __getPriceBreakdown(subvertical ? subvertical.get("JobTitle") : "", fixedInfo.get("BasicPrice"), fixedInfo.get("FixedPrice"), fixedInfo.get("Extras"));
  var signature64Promise;
  if (fixedInfo.has("Signature")) signature64Promise = resImages.extractBase64(fixedInfo.get("Signature").url());else signature64Promise = Promise.resolve(undefined);
  var pdf64Promise = signature64Promise.then(function (signature64) {
    var docDef = pdfTemplates.getFixedJoberNoteDefinition(fixedInfo.get("ID"), resFormat.formatDate(fixedInfo.get("createdAt")), priceBreakdown, user.get("Name"), resFormat.formatPhone(user.get("Phone")), job.get("Address"), subvertical ? subvertical.get("JobTitle") : "", job.get("Description"), subvertical && subvertical.has("Includes") ? subvertical.get("Includes") : [], subvertical && subvertical.has("DoesntInclude") ? subvertical.get("DoesntInclude") : [], signature64 ? "data:image/png;base64," + signature64 : undefined);
    return __createParsePDF(docDef, fixedInfo.get("ID") + "-profesional.pdf");
  });
  return pdf64Promise;
}